export let EVENT_TYPE = /*#__PURE__*/function (EVENT_TYPE) {
  EVENT_TYPE["OPERATIONAL"] = "operational";
  EVENT_TYPE["SCREEN"] = "screen";
  EVENT_TYPE["TRACK"] = "track";
  EVENT_TYPE["UI"] = "ui";
  return EVENT_TYPE;
}({});
export let ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["ACTIVATED"] = "activated";
  ACTION["ADDED"] = "added";
  ACTION["BROWSER_FREEZE"] = "browserFreeze";
  ACTION["CANCELLED"] = "cancelled";
  ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
  ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
  ACTION["CHANGED_ICON"] = "changedIcon";
  ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
  ACTION["CHANGED_LAYOUT"] = "changedLayout";
  ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
  ACTION["CHANGED_TYPE"] = "changedType";
  ACTION["CHANGED_URL"] = "changedUrl";
  ACTION["CLEARED"] = "cleared";
  ACTION["CLICKED"] = "clicked";
  ACTION["CLOSED"] = "closed";
  ACTION["COMMITTED"] = "committed";
  ACTION["CONNECTED_NODES"] = "connectedNodes";
  ACTION["CONVERTED"] = "converted";
  ACTION["COPIED"] = "copied";
  ACTION["CUT"] = "cut";
  ACTION["DEACTIVATED"] = "deactivated";
  ACTION["DECREMENTED"] = "decremented";
  ACTION["DELETED"] = "deleted";
  ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
  ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
  ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
  ACTION["DISMISSED"] = "dismissed";
  ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
  ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
  ACTION["DOUBLE_CLICKED"] = "doubleClicked";
  ACTION["DRAGGED"] = "dragged";
  ACTION["EDITED"] = "edited";
  ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
  ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
  ACTION["EDITOR_MOUNTED"] = "mounted";
  ACTION["EDITOR_TTI"] = "tti";
  ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
  ACTION["RE_RENDERED"] = "reRendered";
  ACTION["ENTERED"] = "entered";
  ACTION["ERRORED"] = "errored";
  ACTION["EXPOSED"] = "exposed";
  ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
  ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
  ACTION["FIND_PERFORMED"] = "findPerformed";
  ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
  ACTION["FORMATTED"] = "formatted";
  ACTION["HELP_OPENED"] = "helpOpened";
  ACTION["HIGHLIGHTED"] = "highlighted";
  ACTION["INCREMENTED"] = "incremented";
  ACTION["INDENTED"] = "indented";
  ACTION["INITIALISED"] = "initialised";
  ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
  ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
  ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
  ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
  ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
  ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
  ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
  ACTION["INSERTED"] = "inserted";
  ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
  ACTION["INVOKED"] = "invoked";
  ACTION["GOT_CONNECTIONS"] = "gotConnections";
  ACTION["LANGUAGE_SELECTED"] = "languageSelected";
  ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
  ACTION["MATCHED"] = "matched";
  ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
  ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
  ACTION["OPENED"] = "opened";
  ACTION["OUTDENTED"] = "outdented";
  ACTION["PASTED"] = "pasted";
  ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
  ACTION["PASTED_TIMED"] = "pastedTimed";
  ACTION["PRESSED"] = "pressed";
  ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
  ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
  ACTION["REPLACED_ALL"] = "replacedAll";
  ACTION["REPLACED_ONE"] = "replacedOne";
  ACTION["RESOLVED"] = "resolved";
  ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
  ACTION["SELECTED"] = "selected";
  ACTION["SHOWN"] = "shown";
  ACTION["SLOW_INPUT"] = "slowInput";
  ACTION["STARTED"] = "started";
  ACTION["STOPPED"] = "stopped";
  ACTION["SUBSTITUTED"] = "autoSubstituted";
  ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
  ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
  ACTION["SYNCHRONY_ERROR"] = "synchronyError";
  ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
  ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
  ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
  ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
  ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
  ACTION["TOGGLE_EXPAND"] = "toggleExpand";
  ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
  ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
  ACTION["TYPING_FINISHED"] = "typingFinished";
  ACTION["TYPING_STARTED"] = "typingStarted";
  ACTION["UNLINK"] = "unlinked";
  ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
  ACTION["UPDATED"] = "updated";
  ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
  ACTION["UPDATED_SOURCE"] = "updatedSource";
  ACTION["UPDATED_TARGET"] = "updatedTarget";
  ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
  ACTION["VIEWED"] = "viewed";
  ACTION["VISITED"] = "visited";
  ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
  ACTION["RENDERED"] = "rendered";
  ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
  ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
  ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
  ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
  ACTION["REMOVE_ICON"] = "removedIcon";
  ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
  ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
  ACTION["RENDERER_TTI"] = "tti";
  ACTION["CRASHED"] = "unhandledErrorCaughtV2";
  ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
  ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
  ACTION["SORT_COLUMN"] = "sortedColumn";
  ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
  ACTION["STEPS_TRACKED"] = "stepsTracked";
  ACTION["STEPS_FILTERED"] = "stepsFiltered";
  ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
  ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
  ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
  ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
  ACTION["RECORD_VIDEO"] = "recordVideo";
  ACTION["INSERT_VIDEO"] = "insertVideo";
  ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
  ACTION["ADD_CHILD"] = "addChild";
  ACTION["CHANGE_ACTIVE"] = "changeActive";
  ACTION["REMOVE_CHILD"] = "removeChild";
  ACTION["UPDATE_PARAMETERS"] = "updateParameters";
  ACTION["GET_CHILDERN"] = "getChildern";
  ACTION["MOVED"] = "moved";
  ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
  ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
  ACTION["UPLOAD_FAILED"] = "uploadFailed";
  ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
  return ACTION;
}({});
export let INPUT_METHOD = /*#__PURE__*/function (INPUT_METHOD) {
  INPUT_METHOD["ASCII"] = "ascii";
  INPUT_METHOD["AUTO"] = "auto";
  INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
  INPUT_METHOD["BUTTON"] = "button";
  INPUT_METHOD["BLUR"] = "blur";
  INPUT_METHOD["CARD"] = "card";
  INPUT_METHOD["CLIPBOARD"] = "clipboard";
  INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
  INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
  INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
  INPUT_METHOD["DRAG"] = "drag";
  INPUT_METHOD["EXTERNAL"] = "external";
  INPUT_METHOD["EXTENSION_API"] = "extensionApi";
  INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
  INPUT_METHOD["FORMATTING"] = "autoformatting";
  INPUT_METHOD["INSERT_MENU"] = "insertMenu";
  INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
  INPUT_METHOD["KEYBOARD"] = "keyboard";
  INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
  INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
  INPUT_METHOD["MANUAL"] = "manual";
  INPUT_METHOD["PICKER"] = "picker";
  INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
  INPUT_METHOD["PREFILL"] = "prefill";
  INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
  INPUT_METHOD["SHORTCUT"] = "shortcut";
  INPUT_METHOD["TOOLBAR"] = "toolbar";
  INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
  INPUT_METHOD["DATASOURCE"] = "datasource_config";
  INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
  INPUT_METHOD["MOUSE"] = "mouse";
  INPUT_METHOD["BROWSER"] = "browser";
  INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
  return INPUT_METHOD;
}({});
export let INSERT_MEDIA_VIA = /*#__PURE__*/function (INSERT_MEDIA_VIA) {
  INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
  INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
  INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
  return INSERT_MEDIA_VIA;
}({});
export let TRIGGER_METHOD = /*#__PURE__*/function (TRIGGER_METHOD) {
  TRIGGER_METHOD["BUTTON"] = "button";
  TRIGGER_METHOD["KEYBOARD"] = "keyboard";
  TRIGGER_METHOD["SHORTCUT"] = "shortcut";
  TRIGGER_METHOD["TOOLBAR"] = "toolbar";
  return TRIGGER_METHOD;
}({});
export let ACTION_SUBJECT = /*#__PURE__*/function (ACTION_SUBJECT) {
  ACTION_SUBJECT["COLLAB"] = "collab";
  ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
  ACTION_SUBJECT["BUTTON"] = "button";
  ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
  ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
  ACTION_SUBJECT["DATE"] = "date";
  ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
  ACTION_SUBJECT["DOCUMENT"] = "document";
  ACTION_SUBJECT["EDITOR"] = "editor";
  ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
  ACTION_SUBJECT["EMBEDS"] = "embeds";
  ACTION_SUBJECT["EXPAND"] = "expand";
  ACTION_SUBJECT["EXTENSION"] = "extension";
  ACTION_SUBJECT["FEATURE"] = "feature";
  ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
  ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
  ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
  ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
  ACTION_SUBJECT["HELP"] = "help";
  ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
  ACTION_SUBJECT["LAYOUT"] = "layout";
  ACTION_SUBJECT["LIST"] = "list";
  ACTION_SUBJECT["MEDIA"] = "media";
  ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
  ACTION_SUBJECT["MENTION"] = "mention";
  ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
  ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
  ACTION_SUBJECT["PANEL"] = "panel";
  ACTION_SUBJECT["PICKER"] = "picker";
  ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
  ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
  ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
  ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
  ACTION_SUBJECT["SELECTION"] = "selection";
  ACTION_SUBJECT["SMART_LINK"] = "smartLink";
  ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
  ACTION_SUBJECT["TABLE"] = "table";
  ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
  ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
  ACTION_SUBJECT["TEXT"] = "text";
  ACTION_SUBJECT["TOOLBAR"] = "toolbar";
  ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
  ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
  ACTION_SUBJECT["ANNOTATION"] = "annotation";
  ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
  ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
  ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
  ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
  ACTION_SUBJECT["RENDERER"] = "renderer";
  ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
  ACTION_SUBJECT["LINK"] = "link";
  ACTION_SUBJECT["TOOLTIP"] = "tooltip";
  ACTION_SUBJECT["LOOM"] = "loom";
  ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
  ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
  ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
  ACTION_SUBJECT["DRAG"] = "drag";
  ACTION_SUBJECT["ELEMENT"] = "element";
  ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
  ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
  ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
  ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
  ACTION_SUBJECT["DECORATION"] = "decoration";
  return ACTION_SUBJECT;
}({});
export let ACTION_SUBJECT_ID = /*#__PURE__*/function (ACTION_SUBJECT_ID) {
  ACTION_SUBJECT_ID["ACTION"] = "action";
  ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
  ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
  ACTION_SUBJECT_ID["ALL"] = "all";
  ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
  ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
  ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
  ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
  ACTION_SUBJECT_ID["BORDER"] = "border";
  ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
  ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
  ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
  ACTION_SUBJECT_ID["CANCEL"] = "cancel";
  ACTION_SUBJECT_ID["CAPTION"] = "caption";
  ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
  ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
  ACTION_SUBJECT_ID["CELL"] = "cell";
  ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
  ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
  ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
  ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
  ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
  ACTION_SUBJECT_ID["DATE"] = "date";
  ACTION_SUBJECT_ID["DATE_DAY"] = "day";
  ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
  ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
  ACTION_SUBJECT_ID["DECISION"] = "decision";
  ACTION_SUBJECT_ID["DIVIDER"] = "divider";
  ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
  ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
  ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
  ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
  ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
  ACTION_SUBJECT_ID["EMOJI"] = "emoji";
  ACTION_SUBJECT_ID["EXPAND"] = "expand";
  ACTION_SUBJECT_ID["EXTENSION"] = "extension";
  ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
  ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
  ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
  ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
  ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
  ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
  ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
  ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
  ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
  ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
  ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
  ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
  ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
  ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
  ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
  ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
  ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
  ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
  ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
  ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
  ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
  ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
  ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
  ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
  ACTION_SUBJECT_ID["LAYOUT"] = "layout";
  ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
  ACTION_SUBJECT_ID["LINK"] = "link";
  ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
  ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
  ACTION_SUBJECT_ID["MEDIA"] = "media";
  ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
  ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
  ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
  ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
  ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
  ACTION_SUBJECT_ID["MENTION"] = "mention";
  ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
  ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
  ACTION_SUBJECT_ID["NODE"] = "node";
  ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
  ACTION_SUBJECT_ID["PANEL"] = "panel";
  ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
  ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
  ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
  ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
  ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
  ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
  ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
  ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
  ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
  ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
  ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
  ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
  ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
  ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
  ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
  ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
  ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
  ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
  ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
  ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
  ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
  ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
  ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
  ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
  ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
  ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
  ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
  ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
  ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
  ACTION_SUBJECT_ID["PUNC"] = "punctuation";
  ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
  ACTION_SUBJECT_ID["RANGE"] = "range";
  ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
  ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
  ACTION_SUBJECT_ID["RESIZED"] = "resized";
  ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
  ACTION_SUBJECT_ID["SAVE"] = "save";
  ACTION_SUBJECT_ID["SECTION"] = "section";
  ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
  ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
  ACTION_SUBJECT_ID["STATUS"] = "status";
  ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
  ACTION_SUBJECT_ID["TABLE"] = "table";
  ACTION_SUBJECT_ID["TEXT"] = "text";
  ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
  ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
  ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
  ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
  ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
  ACTION_SUBJECT_ID["UNLINK"] = "unlink";
  ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
  ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
  ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
  ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
  ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
  ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
  ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
  ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
  ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
  ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
  return ACTION_SUBJECT_ID;
}({});
export let FLOATING_CONTROLS_TITLE = /*#__PURE__*/function (FLOATING_CONTROLS_TITLE) {
  FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
  FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
  FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
  FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
  FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
  FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
  FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
  return FLOATING_CONTROLS_TITLE;
}({});
export let CONTENT_COMPONENT = /*#__PURE__*/function (CONTENT_COMPONENT) {
  CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
  CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
  CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
  CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
  return CONTENT_COMPONENT;
}({});